import { useGetSocialProofAssetsById } from "./api/queries";
import { BaseWidget } from "./components/atoms/base-widget";
import "./index.css";

export default function App() {
  const widgetId = window.location.pathname.split("/").pop();

  const { data: widget, isPending } = useGetSocialProofAssetsById<
    Record<string, unknown>,
    string
  >({ id: widgetId, refId: widgetId });

  if (isPending) return <div className="w-full h-screen"></div>;

  if (!widget)
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <div className="text-center p-4">
          <h3 className="text-lg font-medium">Widget not found</h3>
          <p className="text-muted-foreground">
            The requested widget could not be loaded
          </p>
        </div>
      </div>
    );

  return <BaseWidget id={widget.id} widgetIdentifier={widget.data?.id} />;
}
